import { AuthProvider } from './context/authContext'
import { AppProvider } from './context/appContext'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './sentry'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ToastContainer } from 'react-toastify'
import { MantineProvider } from '@mantine/core'
import './index.css'
import './tailwind-setup.css'
import 'react-toastify/dist/ReactToastify.css'
import { useEffect } from 'react'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { SignalRProvider } from './context/signalrContext'
import Fallback from './components/ui/Fallback'

// Suppress benign ResizeObserver errors: don't remove it, this is normal behavior for tooltips, modals, and responsive UI components
window.addEventListener('error', (e) => {
	if (
		e.message ===
			'ResizeObserver loop completed with undelivered notifications.' ||
		e.message === 'ResizeObserver loop limit exceeded'
	) {
		const resizeObserverErrDiv = document.getElementById(
			'webpack-dev-server-client-overlay',
		)
		const resizeObserverErr = document.getElementById(
			'webpack-dev-server-client-overlay-div',
		)
		if (resizeObserverErr) {
			resizeObserverErr.setAttribute('style', 'display: none')
		}
		if (resizeObserverErrDiv) {
			resizeObserverErrDiv.setAttribute('style', 'display: none')
		}
		e.stopImmediatePropagation()
		e.preventDefault()
	}
})

function RedirectToAura() {
	useEffect(() => {
		if (window.location.pathname === '/') {
			setTimeout(() => {
				window.location.replace('/aura/home')
			}, 2000)
		}
	}, [])

	return null
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {},
		mutations: {},
	},
})

const root = createRoot(document.getElementById('root'))
root.render(
	<AuthProvider>
		<AppProvider>
			<MantineProvider>
				<RedirectToAura />
				<SignalRProvider>
					<BrowserRouter basename="/aura">
						<QueryClientProvider client={queryClient}>
							<ToastContainer />
							<Sentry.ErrorBoundary
								fallback={<Fallback />}
								onError={(error) => {
									Sentry.captureException(error)
								}}
							>
								<App />
							</Sentry.ErrorBoundary>
						</QueryClientProvider>
					</BrowserRouter>
				</SignalRProvider>
			</MantineProvider>
		</AppProvider>
	</AuthProvider>,
)

serviceWorker.unregister()
